import { render, staticRenderFns } from "./BoxPhotoMobile.vue?vue&type=template&id=31a7904c&scoped=true"
import script from "./BoxPhotoMobile.vue?vue&type=script&lang=js"
export * from "./BoxPhotoMobile.vue?vue&type=script&lang=js"
import style0 from "./BoxPhotoMobile.vue?vue&type=style&index=0&id=31a7904c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7904c",
  null
  
)

export default component.exports